import type { TOC } from '@ember/component/template-only';
import SettingsHotelAccessFormsFormUserEdit from 'lumen/components/settings/hotel-access/forms/form-user-edit';
import type MarketSettingsHotelsEditController from 'lumen/controllers/market/settings/hotels/edit';

interface MarketSettingsHotelsEditSignature {
  Args: {
    controller: MarketSettingsHotelsEditController;
    model: unknown;
  };
}

<template>
  <SettingsHotelAccessFormsFormUserEdit
    @changeHotelSearch={{@controller.changeHotelSearch}}
    @editText={{@controller.editText}}
    {{! @glint-expect-error: Incorrect type }}
    @hotelText={{@controller.hotelText}}
    @model={{@controller.model}}
    @redirectOnClose={{@controller.redirectOnClose}}
    @refreshData={{@controller.refreshData}}
    @sortResults={{@controller.sortResults}}
    @userId={{@controller.userId}}
  />
</template> satisfies TOC<MarketSettingsHotelsEditSignature>;
